function initCustomChatbot() {
    if (window.CustomGPT && window.chatbotConfig) {
        CustomGPT.init({
            p_id: window.chatbotConfig.chatbotId,
            p_key: window.chatbotConfig.chatbotKey
        });
    }
}

export { initCustomChatbot };
